import React from 'react'
import { Navigate, useLocation } from 'react-router-dom'

/**
 * @param {{ to: string }} props
 */
export default function RedirectPreserveSearch({ to }) {
  const { search } = useLocation()
  return <Navigate to={`${to}${search}`} replace />
}
